import { ENDPOINTS } from '@/util'
import { toast } from 'sonner'
import DOMPurify from 'isomorphic-dompurify'
import type { SharedFileItem } from './applicationFileTree'

export const downloadSharedFile = async (file: SharedFileItem, appKey: string) => {
  const token = JSON.parse(sessionStorage.getItem('token') ?? '')
  try {
    const params = new URLSearchParams()
    if (file.encryptedBlobName) params.set('encryptedBlobName', file.encryptedBlobName)
    params.set('appKey', appKey)

    const response = await fetch(`${ENDPOINTS.LANDING}/storage/download_shared_file/?${params.toString()}`, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    })

    if (response.ok) {
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.setAttribute('href', url)
      a.setAttribute('download', file.fileName ?? 'download')
      document.body.appendChild(a)
      a.click()
      a.remove()
    } else {
      let errMessage = 'Unknown error'
      if (response.statusText) errMessage = response.statusText
      try {
        const tryJson = await response.json()
        if (tryJson.Message) errMessage = tryJson.Message
      } catch {
        // ignore
      }
      toast.error(`Error downloading file: ${errMessage}`)
    }
  } catch (error) {
    toast.error(`Error downloading file: ${DOMPurify.sanitize(`${error}`)}`)
    console.error(DOMPurify.sanitize(`${error}`))
  }
}
